import { configureStore } from '@reduxjs/toolkit';

import bookmarkSlice from '../pages/Dashboard/BookmarkSlice';
import notificationSlice from '../components/Notification/NotificationSlice';
import packageLimitSlice from '../components/PackageLimitModal/PackageLimitModalSlice';
import userInfoSliceSlice from '../layout/UserInfoSlice';
import appInfoSliceSlice from '../layout/AppInfoSlice';
import liveSlice from '../pages/SpecialExchange/LiveSlice';
import aiAgentSlice from '../pages/AIAgent/AIAgentSlice';

const store = configureStore({
  reducer: {
    bookmark: bookmarkSlice,
    notification: notificationSlice,
    packageLimit: packageLimitSlice,
    userInfo: userInfoSliceSlice,
    appInfo: appInfoSliceSlice,
    liveData: liveSlice,
    aiAgent: aiAgentSlice,
  },
});

export default store;
